import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

type Props = {
  onClick: () => void;
  active: boolean;
};

const TabButton = ({ onClick, active, children }: PropsWithChildren<Props>) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      'w-full py-3 text-center cursor-pointer font-semibold',
      active && 'text-primary-500 border-b-4 border-primary-400'
    )}
  >
    {children}
  </button>
);

export default TabButton;
